import React, { Component } from 'react';

class Beacon extends Component {
  componentDidMount() {
    this.loadBeaconScript();
  }

  componentDidUpdate(prevProps) {
    // Re-initialize if beaconId or user changed
    if (prevProps.beaconId !== this.props.beaconId || prevProps.user !== this.props.user) {
      this.initBeacon();
    }
  }

  componentWillUnmount() {
    if (window.Beacon) {
      window.Beacon('destroy');
    }
  }

  loadBeaconScript = () => {
    if (window.Beacon) {
      this.initBeacon();
      return;
    }

    (function (e, t, n) {
      function a() {
        var e = t.getElementsByTagName('script')[0],
          n = t.createElement('script');
        n.type = 'text/javascript';
        n.async = true;
        n.src = 'https://beacon-v2.helpscout.net';
        e.parentNode.insertBefore(n, e);
      }
      if (e.Beacon = n = function (t, n, a) {
        e.Beacon.readyQueue.push({ method: t, options: n, data: a });
      }, n.readyQueue = [], t.readyState === 'complete') {
        return a();
      }
      e.attachEvent ? e.attachEvent('onload', a) : e.addEventListener('load', a, false);
    })(window, document, window.Beacon || function () {});

    // Wait a little for Beacon to load
    setTimeout(this.initBeacon, 1000);
  };

  initBeacon = () => {
    if (!window.Beacon) return;

    window.Beacon('init', this.props.beaconId);

    setTimeout(() => {
        console.log('myname',this.props.user.name)
        if (this.props.user && this.props.user.email) {
          window.Beacon('identify', {
            name: this.props.user.name,
            email: this.props.user.email,
            company: this.props.user.businessName,
          });
        }
      }, 2000);
  };

  render() {
    return null; // This component does not render anything visually
  }
}

export default Beacon;
